import { IClassname } from '@/lib/shared/model/classname';

export const HDTV = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.94291 5.77637H30.0571C30.2265 5.77637 30.3891 5.84369 30.5089 5.96351C30.6287 6.08334 30.696 6.24586 30.696 6.41533V23.0282H1.94291C1.77345 23.0282 1.61093 22.9609 1.4911 22.8411C1.37127 22.7213 1.30396 22.5587 1.30396 22.3893V6.41533C1.30396 6.24586 1.37127 6.08334 1.4911 5.96351C1.61093 5.84369 1.77345 5.77637 1.94291 5.77637Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.49866 23.0283L2.58179 26.2231"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5012 23.0283L29.4181 26.2231"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
